import { render, staticRenderFns } from "./Vorberatenden_Kommission_Gesetzte.vue?vue&type=template&id=6863aa28&scoped=true&"
import script from "./Vorberatenden_Kommission_Gesetzte.vue?vue&type=script&lang=js&"
export * from "./Vorberatenden_Kommission_Gesetzte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6863aa28",
  null
  
)

export default component.exports